import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'pa-member-login',
  templateUrl: './member-login.component.html',
  styleUrls: ['./member-login.component.scss']
})
export class MemberLoginComponent implements OnInit {

  trackingId: string;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });
  }

  otpPage() {
    this.router.navigate(['/otp', this.trackingId]);
  }

  forgotPassword() {
   this.router.navigate(['/notification/forgot-password', this.trackingId]);
  }

  signupRouting() {
    this.router.navigate(['/sign-up']);
  }
}
